









import { IsMens } from '@/utils/app-setting';
import { Component, Vue } from 'vue-property-decorator'
import PrivacyPolicyPageForMens from './privacyPolicyForMens.vue'
import PrivacyPolicyPageForWoMens from './privacyPolicyForWoMens.vue';

@Component({
  name: 'PrivacyPolicyPage',
  components: {
    PrivacyPolicyPageForMens,
    PrivacyPolicyPageForWoMens
  }
})
export default class PrivacyPolicyPage extends Vue {
  public isMan = IsMens()
}
